module.exports = __webpack_public_path__ + "static/media/project8.9793675b.png";